import React, { useState, useContext } from 'react';
import { Calendar as CalendarIcon, ChevronLeft, ChevronRight, Info } from 'lucide-react';
import { UserContext } from '../../context/UserContext';
interface HolidayEvent {
  date: string; // Format: YYYY-MM-DD
  name: string;
  type: 'ferie' | 'ccq' | 'company';
  description?: string;
}
export function CompanyCalendar() {
  const {
    userRole,
    userName
  } = useContext(UserContext);
  // Mettre la date actuelle à décembre 2025
  const [currentDate, setCurrentDate] = useState(new Date(2025, 11, 1)); // 11 = décembre (0-indexed)
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  // Jours fériés du Québec et congés CCQ 2024-2026
  const holidays: HolidayEvent[] = [
  // Jours fériés 2024
  {
    date: '2024-01-01',
    name: "Jour de l'An",
    type: 'ferie',
    description: 'Férié payé'
  }, {
    date: '2024-03-29',
    name: 'Vendredi Saint',
    type: 'ferie',
    description: 'Férié payé'
  }, {
    date: '2024-05-20',
    name: 'Journée nationale des Patriotes',
    type: 'ferie',
    description: 'Férié payé'
  }, {
    date: '2024-06-24',
    name: 'Fête nationale du Québec',
    type: 'ferie',
    description: 'Férié payé'
  }, {
    date: '2024-07-01',
    name: 'Fête du Canada',
    type: 'ferie',
    description: 'Férié payé'
  }, {
    date: '2024-09-02',
    name: 'Fête du Travail',
    type: 'ferie',
    description: 'Férié payé'
  }, {
    date: '2024-10-14',
    name: 'Action de grâce',
    type: 'ferie',
    description: 'Férié payé'
  }, {
    date: '2024-12-25',
    name: 'Noël',
    type: 'ferie',
    description: 'Férié payé'
  }, {
    date: '2024-12-26',
    name: 'Lendemain de Noël',
    type: 'ferie',
    description: 'Férié payé'
  },
  // Congés CCQ Construction 2024 (2 semaines obligatoires en été)
  {
    date: '2024-07-22',
    name: 'Congé CCQ - Semaine 1',
    type: 'ccq',
    description: 'Congé obligatoire de la construction'
  }, {
    date: '2024-07-23',
    name: 'Congé CCQ - Semaine 1',
    type: 'ccq',
    description: 'Congé obligatoire de la construction'
  }, {
    date: '2024-07-24',
    name: 'Congé CCQ - Semaine 1',
    type: 'ccq',
    description: 'Congé obligatoire de la construction'
  }, {
    date: '2024-07-25',
    name: 'Congé CCQ - Semaine 1',
    type: 'ccq',
    description: 'Congé obligatoire de la construction'
  }, {
    date: '2024-07-26',
    name: 'Congé CCQ - Semaine 1',
    type: 'ccq',
    description: 'Congé obligatoire de la construction'
  }, {
    date: '2024-07-29',
    name: 'Congé CCQ - Semaine 2',
    type: 'ccq',
    description: 'Congé obligatoire de la construction'
  }, {
    date: '2024-07-30',
    name: 'Congé CCQ - Semaine 2',
    type: 'ccq',
    description: 'Congé obligatoire de la construction'
  }, {
    date: '2024-07-31',
    name: 'Congé CCQ - Semaine 2',
    type: 'ccq',
    description: 'Congé obligatoire de la construction'
  }, {
    date: '2024-08-01',
    name: 'Congé CCQ - Semaine 2',
    type: 'ccq',
    description: 'Congé obligatoire de la construction'
  }, {
    date: '2024-08-02',
    name: 'Congé CCQ - Semaine 2',
    type: 'ccq',
    description: 'Congé obligatoire de la construction'
  },
  // Congés de fin d'année 2024 (période des Fêtes)
  {
    date: '2024-12-27',
    name: 'Congé des Fêtes',
    type: 'company',
    description: 'Fermeture de la compagnie'
  }, {
    date: '2024-12-30',
    name: 'Congé des Fêtes',
    type: 'company',
    description: 'Fermeture de la compagnie'
  }, {
    date: '2024-12-31',
    name: 'Congé des Fêtes',
    type: 'company',
    description: 'Fermeture de la compagnie'
  },
  // Jours fériés 2025
  {
    date: '2025-01-01',
    name: "Jour de l'An",
    type: 'ferie',
    description: 'Férié payé'
  }, {
    date: '2025-04-18',
    name: 'Vendredi Saint',
    type: 'ferie',
    description: 'Férié payé'
  }, {
    date: '2025-05-19',
    name: 'Journée nationale des Patriotes',
    type: 'ferie',
    description: 'Férié payé'
  }, {
    date: '2025-06-24',
    name: 'Fête nationale du Québec',
    type: 'ferie',
    description: 'Férié payé'
  }, {
    date: '2025-07-01',
    name: 'Fête du Canada',
    type: 'ferie',
    description: 'Férié payé'
  }, {
    date: '2025-09-01',
    name: 'Fête du Travail',
    type: 'ferie',
    description: 'Férié payé'
  }, {
    date: '2025-10-13',
    name: 'Action de grâce',
    type: 'ferie',
    description: 'Férié payé'
  }, {
    date: '2025-12-25',
    name: 'Noël',
    type: 'ferie',
    description: 'Férié payé'
  }, {
    date: '2025-12-26',
    name: 'Lendemain de Noël',
    type: 'ferie',
    description: 'Férié payé'
  },
  // Congés CCQ Construction 2025 (2 semaines obligatoires en été)
  {
    date: '2025-07-21',
    name: 'Congé CCQ - Semaine 1',
    type: 'ccq',
    description: 'Congé obligatoire de la construction'
  }, {
    date: '2025-07-22',
    name: 'Congé CCQ - Semaine 1',
    type: 'ccq',
    description: 'Congé obligatoire de la construction'
  }, {
    date: '2025-07-23',
    name: 'Congé CCQ - Semaine 1',
    type: 'ccq',
    description: 'Congé obligatoire de la construction'
  }, {
    date: '2025-07-24',
    name: 'Congé CCQ - Semaine 1',
    type: 'ccq',
    description: 'Congé obligatoire de la construction'
  }, {
    date: '2025-07-25',
    name: 'Congé CCQ - Semaine 1',
    type: 'ccq',
    description: 'Congé obligatoire de la construction'
  }, {
    date: '2025-07-28',
    name: 'Congé CCQ - Semaine 2',
    type: 'ccq',
    description: 'Congé obligatoire de la construction'
  }, {
    date: '2025-07-29',
    name: 'Congé CCQ - Semaine 2',
    type: 'ccq',
    description: 'Congé obligatoire de la construction'
  }, {
    date: '2025-07-30',
    name: 'Congé CCQ - Semaine 2',
    type: 'ccq',
    description: 'Congé obligatoire de la construction'
  }, {
    date: '2025-07-31',
    name: 'Congé CCQ - Semaine 2',
    type: 'ccq',
    description: 'Congé obligatoire de la construction'
  }, {
    date: '2025-08-01',
    name: 'Congé CCQ - Semaine 2',
    type: 'ccq',
    description: 'Congé obligatoire de la construction'
  },
  // Congés de fin d'année 2025 (période des Fêtes)
  {
    date: '2025-12-22',
    name: 'Congé des Fêtes',
    type: 'company',
    description: 'Fermeture de la compagnie'
  }, {
    date: '2025-12-23',
    name: 'Congé des Fêtes',
    type: 'company',
    description: 'Fermeture de la compagnie'
  }, {
    date: '2025-12-24',
    name: 'Congé des Fêtes',
    type: 'company',
    description: 'Fermeture de la compagnie'
  }, {
    date: '2025-12-29',
    name: 'Congé des Fêtes',
    type: 'company',
    description: 'Fermeture de la compagnie'
  }, {
    date: '2025-12-30',
    name: 'Congé des Fêtes',
    type: 'company',
    description: 'Fermeture de la compagnie'
  }, {
    date: '2025-12-31',
    name: 'Congé des Fêtes',
    type: 'company',
    description: 'Fermeture de la compagnie'
  },
  // Jours fériés 2026
  {
    date: '2026-01-01',
    name: "Jour de l'An",
    type: 'ferie',
    description: 'Férié payé'
  }, {
    date: '2026-01-02',
    name: 'Congé des Fêtes',
    type: 'company',
    description: 'Fermeture de la compagnie'
  }, {
    date: '2026-04-03',
    name: 'Vendredi Saint',
    type: 'ferie',
    description: 'Férié payé'
  }, {
    date: '2026-05-18',
    name: 'Journée nationale des Patriotes',
    type: 'ferie',
    description: 'Férié payé'
  }, {
    date: '2026-06-24',
    name: 'Fête nationale du Québec',
    type: 'ferie',
    description: 'Férié payé'
  }, {
    date: '2026-07-01',
    name: 'Fête du Canada',
    type: 'ferie',
    description: 'Férié payé'
  }, {
    date: '2026-09-07',
    name: 'Fête du Travail',
    type: 'ferie',
    description: 'Férié payé'
  }, {
    date: '2026-10-12',
    name: 'Action de grâce',
    type: 'ferie',
    description: 'Férié payé'
  }, {
    date: '2026-12-25',
    name: 'Noël',
    type: 'ferie',
    description: 'Férié payé'
  }, {
    date: '2026-12-26',
    name: 'Lendemain de Noël',
    type: 'ferie',
    description: 'Férié payé'
  },
  // Congés CCQ Construction 2026 (2 semaines obligatoires en été)
  {
    date: '2026-07-20',
    name: 'Congé CCQ - Semaine 1',
    type: 'ccq',
    description: 'Congé obligatoire de la construction'
  }, {
    date: '2026-07-21',
    name: 'Congé CCQ - Semaine 1',
    type: 'ccq',
    description: 'Congé obligatoire de la construction'
  }, {
    date: '2026-07-22',
    name: 'Congé CCQ - Semaine 1',
    type: 'ccq',
    description: 'Congé obligatoire de la construction'
  }, {
    date: '2026-07-23',
    name: 'Congé CCQ - Semaine 1',
    type: 'ccq',
    description: 'Congé obligatoire de la construction'
  }, {
    date: '2026-07-24',
    name: 'Congé CCQ - Semaine 1',
    type: 'ccq',
    description: 'Congé obligatoire de la construction'
  }, {
    date: '2026-07-27',
    name: 'Congé CCQ - Semaine 2',
    type: 'ccq',
    description: 'Congé obligatoire de la construction'
  }, {
    date: '2026-07-28',
    name: 'Congé CCQ - Semaine 2',
    type: 'ccq',
    description: 'Congé obligatoire de la construction'
  }, {
    date: '2026-07-29',
    name: 'Congé CCQ - Semaine 2',
    type: 'ccq',
    description: 'Congé obligatoire de la construction'
  }, {
    date: '2026-07-30',
    name: 'Congé CCQ - Semaine 2',
    type: 'ccq',
    description: 'Congé obligatoire de la construction'
  }, {
    date: '2026-07-31',
    name: 'Congé CCQ - Semaine 2',
    type: 'ccq',
    description: 'Congé obligatoire de la construction'
  }];
  const getMonthName = (date: Date) => {
    return date.toLocaleDateString('fr-CA', {
      month: 'long',
      year: 'numeric'
    });
  };
  const getDaysInMonth = (date: Date) => {
    const year = date.getFullYear();
    const month = date.getMonth();
    return new Date(year, month + 1, 0).getDate();
  };
  const getFirstDayOfMonth = (date: Date) => {
    const year = date.getFullYear();
    const month = date.getMonth();
    const firstDay = new Date(year, month, 1).getDay();
    // Convertir dimanche (0) en 7 pour que lundi soit 1
    return firstDay === 0 ? 7 : firstDay;
  };
  const previousMonth = () => {
    setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() - 1));
  };
  const nextMonth = () => {
    setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() + 1));
  };
  const formatDate = (date: Date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };
  const getHolidayForDate = (date: Date): HolidayEvent | undefined => {
    const dateStr = formatDate(date);
    return holidays.find(h => h.date === dateStr);
  };
  const isToday = (date: Date) => {
    const today = new Date(2025, 11, 15); // Simuler qu'on est le 15 décembre 2025
    return date.getDate() === today.getDate() && date.getMonth() === today.getMonth() && date.getFullYear() === today.getFullYear();
  };
  const isWeekend = (date: Date) => {
    const day = date.getDay();
    return day === 0 || day === 6;
  };
  const handleDateClick = (date: Date) => {
    setSelectedDate(date);
  };
  const renderCalendar = () => {
    const daysInMonth = getDaysInMonth(currentDate);
    const firstDay = getFirstDayOfMonth(currentDate);
    const days = [];
    // Jours vides avant le premier jour du mois
    for (let i = 1; i < firstDay; i++) {
      days.push(<div key={`empty-${i}`} className="h-24 bg-gray-50" data-id="element-82"></div>);
    }
    // Jours du mois
    for (let day = 1; day <= daysInMonth; day++) {
      const date = new Date(currentDate.getFullYear(), currentDate.getMonth(), day);
      const holiday = getHolidayForDate(date);
      const isTodayDate = isToday(date);
      const isWeekendDate = isWeekend(date);
      days.push(<div key={day} onClick={() => handleDateClick(date)} className={`h-24 border border-gray-200 p-2 cursor-pointer transition-all hover:shadow-md ${isTodayDate ? 'ring-2 ring-blue-500' : ''} ${holiday?.type === 'ferie' ? 'bg-red-50' : holiday?.type === 'ccq' ? 'bg-orange-50' : holiday?.type === 'company' ? 'bg-purple-50' : isWeekendDate ? 'bg-gray-100' : 'bg-white'}`} data-id="element-83">
          <div className="flex items-center justify-between mb-1" data-id="element-84">
            <span className={`text-sm font-medium ${isTodayDate ? 'text-blue-600 font-bold' : holiday ? 'text-gray-900' : isWeekendDate ? 'text-gray-500' : 'text-gray-700'}`} data-id="element-85">
              {day}
            </span>
            {holiday && <span className={`text-xs px-1.5 py-0.5 rounded ${holiday.type === 'ferie' ? 'bg-red-200 text-red-800' : holiday.type === 'ccq' ? 'bg-orange-200 text-orange-800' : 'bg-purple-200 text-purple-800'}`} data-id="element-86">
                {holiday.type === 'ferie' ? 'Férié' : holiday.type === 'ccq' ? 'CCQ' : 'Congé'}
              </span>}
          </div>
          {holiday && <p className="text-xs text-gray-700 line-clamp-2 leading-tight" data-id="element-87">
              {holiday.name}
            </p>}
        </div>);
    }
    return days;
  };
  const selectedHoliday = selectedDate ? getHolidayForDate(selectedDate) : null;
  return <div className="pb-20 md:pb-0" data-id="element-88">
      <div className="mb-6" data-id="element-89">
        <h1 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-90">
          Calendrier de la compagnie
        </h1>
        <p className="text-gray-600" data-id="element-91">
          Jours fériés, congés CCQ et fermetures de la compagnie
        </p>
      </div>

      {/* Légende */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 mb-6" data-id="element-92">
        <h2 className="text-sm font-semibold text-gray-900 mb-3 flex items-center gap-2" data-id="element-93">
          <Info className="h-4 w-4" data-id="element-94" />
          Légende
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3" data-id="element-95">
          <div className="flex items-center gap-2" data-id="element-96">
            <div className="w-6 h-6 bg-red-50 border-2 border-red-200 rounded" data-id="element-97"></div>
            <span className="text-sm text-gray-700" data-id="element-98">Jours fériés payés</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-99">
            <div className="w-6 h-6 bg-orange-50 border-2 border-orange-200 rounded" data-id="element-100"></div>
            <span className="text-sm text-gray-700" data-id="element-101">
              Congés CCQ (construction)
            </span>
          </div>
          <div className="flex items-center gap-2" data-id="element-102">
            <div className="w-6 h-6 bg-purple-50 border-2 border-purple-200 rounded" data-id="element-103"></div>
            <span className="text-sm text-gray-700" data-id="element-104">Fermeture compagnie</span>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow-sm border border-gray-200" data-id="element-105">
        {/* En-tête du calendrier */}
        <div className="flex items-center justify-between p-4 border-b border-gray-200" data-id="element-106">
          <button onClick={previousMonth} className="p-2 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-107">
            <ChevronLeft className="h-5 w-5 text-gray-600" data-id="element-108" />
          </button>
          <h2 className="text-lg font-semibold text-gray-900 capitalize" data-id="element-109">
            {getMonthName(currentDate)}
          </h2>
          <button onClick={nextMonth} className="p-2 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-110">
            <ChevronRight className="h-5 w-5 text-gray-600" data-id="element-111" />
          </button>
        </div>

        {/* Jours de la semaine */}
        <div className="grid grid-cols-7 border-b border-gray-200" data-id="element-112">
          {['Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', 'Dim'].map(day => <div key={day} className="py-3 text-center text-sm font-semibold text-gray-700 bg-gray-50" data-id="element-113">
              {day}
            </div>)}
        </div>

        {/* Grille du calendrier */}
        <div className="grid grid-cols-7" data-id="element-114">{renderCalendar()}</div>
      </div>

      {/* Détails de la date sélectionnée */}
      {selectedDate && <div className="mt-6 bg-white rounded-lg shadow-sm border border-gray-200 p-6" data-id="element-115">
          <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-116">
            {selectedDate.toLocaleDateString('fr-CA', {
          weekday: 'long',
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        })}
          </h3>
          {selectedHoliday ? <div className="space-y-3" data-id="element-117">
              <div className="flex items-start gap-3" data-id="element-118">
                <CalendarIcon className={`h-5 w-5 mt-0.5 ${selectedHoliday.type === 'ferie' ? 'text-red-600' : selectedHoliday.type === 'ccq' ? 'text-orange-600' : 'text-purple-600'}`} data-id="element-119" />
                <div data-id="element-120">
                  <p className="font-medium text-gray-900" data-id="element-121">
                    {selectedHoliday.name}
                  </p>
                  <p className="text-sm text-gray-600 mt-1" data-id="element-122">
                    {selectedHoliday.description}
                  </p>
                  <span className={`inline-block mt-2 text-xs px-2 py-1 rounded ${selectedHoliday.type === 'ferie' ? 'bg-red-100 text-red-800' : selectedHoliday.type === 'ccq' ? 'bg-orange-100 text-orange-800' : 'bg-purple-100 text-purple-800'}`} data-id="element-123">
                    {selectedHoliday.type === 'ferie' ? 'Jour férié payé' : selectedHoliday.type === 'ccq' ? 'Congé obligatoire CCQ' : 'Fermeture de la compagnie'}
                  </span>
                </div>
              </div>
            </div> : isWeekend(selectedDate) ? <p className="text-gray-600" data-id="element-124">Fin de semaine</p> : <p className="text-gray-600" data-id="element-125">Journée de travail régulière</p>}
        </div>}

      {/* Liste des prochains congés */}
      <div className="mt-6 bg-white rounded-lg shadow-sm border border-gray-200 p-6" data-id="element-126">
        <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-127">
          Prochains congés et jours fériés
        </h3>
        <div className="space-y-3" data-id="element-128">
          {holidays.filter(h => new Date(h.date) >= new Date(2025, 11, 15)) // À partir du 15 décembre 2025
        .slice(0, 8).map(holiday => <div key={holiday.date} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg" data-id="element-129">
                <div className="flex items-center gap-3" data-id="element-130">
                  <div className={`w-2 h-2 rounded-full ${holiday.type === 'ferie' ? 'bg-red-500' : holiday.type === 'ccq' ? 'bg-orange-500' : 'bg-purple-500'}`} data-id="element-131"></div>
                  <div data-id="element-132">
                    <p className="font-medium text-gray-900" data-id="element-133">{holiday.name}</p>
                    <p className="text-xs text-gray-600" data-id="element-134">
                      {holiday.description}
                    </p>
                  </div>
                </div>
                <span className="text-sm text-gray-600" data-id="element-135">
                  {new Date(holiday.date).toLocaleDateString('fr-CA', {
              month: 'short',
              day: 'numeric',
              year: 'numeric'
            })}
                </span>
              </div>)}
        </div>
      </div>
    </div>;
}